import React, { createContext, useContext, useState, useEffect } from 'react'
import { lightTheme, darkTheme } from '../../../../apps/super-app/src/Theme'
import { ThemeProvider } from 'styled-components'
import { getUserTheme, setUserTheme } from './localStorage'
import PropTypes from 'prop-types';

const ThemeContext = createContext()

export const useAppTheme = () => useContext(ThemeContext)

export const AppThemeProvider = ({ children }) => {
    const [themeKey, setThemeKey] = useState(getUserTheme() || 'dark')

    useEffect(() => {
        setUserTheme(themeKey) // keep localStorage in sync
    }, [themeKey])

    const getSystemTheme = () =>
        window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light'

    // Resolve actual theme based on key
    const resolvedThemeKey = themeKey === 'system' ? getSystemTheme() : themeKey

    const selectedTheme =
        resolvedThemeKey.toLowerCase() === 'dark' ? darkTheme : lightTheme

    const toggleTheme = (key) => {
        setThemeKey(key) // "light", "dark", or "system"
    }

    return (
        <ThemeContext.Provider value={{ themeKey, toggleTheme, resolvedThemeKey }}>
            <ThemeProvider theme={selectedTheme}>{children}</ThemeProvider>
        </ThemeContext.Provider>
    )
}
AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};